import { Fragment, useEffect, useState } from 'react';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { ShowToast } from '../../../../common/Toastr';
import Loader from '../../../../common/Loader';
import fetchAPI from '../../../../common/fetchAPI';
import Select, { StylesConfig } from 'react-select';
import { dropDownSelectionStyles, getValueFromResource } from '../../../../common/timeLiveFunction';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks';

const initialValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  phoneNo: "",
  emailAddress: "",
  password: "",
  subdomain: "",
  CreatedFromIP: ""
}

var base_url = window.origin + '/classic/';
const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

export function Registration() {
   const { t } = useTranslation();
  const [registrationValues, setRegistrationValues] = useState<any | ''>(initialValues);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();
  const [countryArray, SetCountryArray] = useState<any | ''>([]);
  const [selectedOptionCountry, setselectedOptionCountry] = useState<{ [key: string]: any }>(
  // { value: "233", label: "United States" }   // 👈 default selected
);

  const navigate = useNavigate();
  const { maxMenuHeight } = useAppSelector((state) => state.globalState)
  // const getCountryAsync = async (country :any) => {
  //   const response = await fetchAPI("api/ExpensePolicies/GetCountry", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
  //   const json = await response.json();
  //   const countryOptions = json.map((item: any) => ({
  //     value: item.CountryId,
  //     label: item.Abbreviation
  //   }));

  //   SetCountryArray(countryOptions);     
  //   const defaultCountry = countryOptions.find(
  //     (c: any) => c.label === country
  //   );   
  //   if (defaultCountry) {
  //     setselectedOptionCountry({ value: defaultCountry.value, label: defaultCountry.label });
  //   }
  // };




  if (NODE_ENV === "development") {
    base_url = REACT_APP_TIMELIVE_API_URL as string;
  }
useEffect(() => {
  fetch("https://ipinfo.io/json")  
    .then(res => res.json())
    .then(data => {
      setRegistrationValues((prev: any) => ({
        ...prev,
        CreatedFromIP: data.ip
        // Country: data.country   
      }));
     
      // getCountryAsync(data.country);  
    })
    .catch(err => {
       setRegistrationValues((prev: any) => ({
        ...prev,
        CreatedFromIP: "127.0.0.1"
        // Country: "US",
      }));
      // getCountryAsync("US");
      console.log("Error fetching country", err)
    });
}, []);




  const checkSubDomain = async (subdomain: any, setFieldError: any, setFieldValue: any) => {
    if (!subdomain) {
      setFieldError('subdomain', 'Subdomain is required');
      return;
    }
    try {
      const response: any = await fetch(`${base_url}api/Account/SubdomainAvailability/${subdomain}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const json = await response.json();
      if (json.availability === "AVAILABLE") {
        setFieldValue('subdomain', subdomain);
      } else {
        setFieldError('subdomain', `${subdomain} is not avaiable`);
      }
    } catch (error) {
      setFieldError('subdomain', 'Error checking subdomain availability');
    }
  }

  const addAccount = async (value: any) => {
    try {
      setIsLoading(true);
      const { firstName, lastName, companyName, phoneNo, emailAddress, password, subdomain, CreatedFromIP } = value;
      let object = {
        "FirstName": firstName,
        "LastName": lastName,
        "CompanyName": companyName,
        "EmailAddress": emailAddress,
        "Password": password,
        "PhoneNumber": phoneNo,
        "Subdomain": subdomain,
        "EmailURL": window.origin,
        "IsFromReact": true,
        // "CountryId": selectedOptionCountry?.value,
        "CountryId": 233,
        "CreatedFromIP": CreatedFromIP
      }
      const response: any = await fetch(`${base_url}api/Account/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(object)
      });
      const json = await response.json();
      if (json[0].hasOwnProperty('Message')) {
        ShowToast('Error', json[0].Message, "error", "toast-top-right");
      } else {
        navigate('/auth/login');
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  const handleChangeCountry = (data: any, Name: string, values: any) => {
    const { value, label } = data;
    setselectedOptionCountry({ value: value, label: label });
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="h-screen w-screen relative overflow-hidden">
        <div
          className="d-flex flex-column flex-root"
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '100vh',
            width: '100%',
            position: 'absolute'
            //backgroundColor: '#f2f6f8'
          }}
        >
          <div className="d-flex flex-column flex-lg-row flex-column-fluid">
            <div className="d-flex flex-lg-row-fluid">
              <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
                <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                  Fast, Efficient and Productive
                </h1>
                <div className="color-TextDarkBlue fs-base text-center fw-semibold">
                  Discover the ultimate time tracking software designed to streamline your business operations.
                  <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
                </div>
                {/* <div className="text-gray-600 fs-base text-center fw-semibold">
                In this kind of post, <a href="#" className="opacity-75-hover text-primary me-1">the blogger</a>
                introduces a person they’ve interviewed <br /> and provides some background information about
                <a href="#" className="opacity-75-hover text-primary me-1">the interviewee</a>
                and their <br /> work following this is a transcript of the interview.
              </div> */}
              </div>
            </div>
            <Formik
              initialValues={registrationValues}
              enableReinitialize={true}
              onSubmit={values => { addAccount(values) }}
              validationSchema={yup.object().shape({
                firstName: yup
                  .string()
                  .label('First Name')
                  .required(),
                lastName: yup
                  .string()
                  .label('Last Name')
                  .required(),
                companyName: yup
                  .string()
                  .label('Company Name')
                  .required(),
                phoneNo: yup
                  .string()
                  .label('Phone No')
                  .required(),
                emailAddress: yup
                  .string()
                  .label('Email Address')
                  .required()
                  .email('Invalid email address'),
                password: yup
                  .string()
                  .label('Password')
                  .required(),
                subdomain: yup
                  .string()
                  .label('Subdomain')
                  .matches(/^[a-zA-Z0-9-]+$/, 'Only alphanumeric characters and hyphens are allowed')
                  .min(5)
                  .max(15)
                  .required()
              })}
            >
              {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm, setFieldError, handleBlur }) => (
                <Fragment>
                  <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                    <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow">
                      <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-550px">
                        <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                          <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                            <div className="text-center mb-10">
                              <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                                className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                              />
                              <div className="text-gray-500 fs-4">
                                Optimize your business operations with TimeLive
                                {/* Effortless Time Management and Team Collaboration with Timelive. */}
                              </div>
                            </div>
                            <div className="row mb-8 mt-12">
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  placeholder="First Name"
                                  name="firstName"
                                  value={values.firstName}
                                  onChange={handleChange('firstName')}
                                  className='form-control fs-6 fw-normal'
                                />
                                <div>
                                  {touched.firstName && errors.firstName &&
                                    <p className='errorMsg'>{errors.firstName as string}</p>
                                  }
                                </div>
                              </div>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  placeholder="Last Name"
                                  name="lastName"
                                  value={values.lastName}
                                  onChange={handleChange('lastName')}
                                  className='form-control fs-6 fw-normal'
                                />
                                <div>
                                  {touched.lastName && errors.lastName &&
                                    <p className='errorMsg'>{errors.lastName as string}</p>
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  placeholder="Company Name"
                                  name="companyName"
                                  value={values.companyName}
                                  onChange={handleChange('companyName')}
                                  className='form-control fs-6 fw-normal'
                                />
                                <div>
                                  {touched.companyName && errors.companyName &&
                                    <p className='errorMsg'>{errors.companyName as string}</p>
                                  }
                                </div>
                              </div>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  placeholder="Phone No"
                                  name="phoneNo"
                                  value={values.phoneNo}
                                  onChange={handleChange('phoneNo')}
                                  className='form-control fs-6 fw-normal'
                                />
                                <div>
                                  {touched.phoneNo && errors.phoneNo &&
                                    <p className='errorMsg'>{errors.phoneNo as string}</p>
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-md-6">
                                <input
                                  type="email"
                                  placeholder="Email"
                                  name="emailAddress"
                                  value={values.emailAddress}
                                  onChange={handleChange('emailAddress')}
                                  className='form-control fs-6 fw-normal'
                                />
                                <div>
                                  {touched.emailAddress && errors.emailAddress &&
                                    <p className='errorMsg'>{errors.emailAddress as string}</p>
                                  }
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="wrapper">
                                  <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange('password')}
                                    className='form-control fs-6 fw-normal'
                                  />
                                  <span
                                    className="insideField-Icons form-label fs-6 fw-normal cursor"
                                    onClick={togglePasswordVisibility}
                                  >
                                    {showPassword ? (
                                      <i className="bi bi-eye-slash-fill text-gray"></i>
                                    ) : (
                                      <i className="bi bi-eye-fill text-gray"></i>
                                    )}
                                  </span>
                                </div>
                                <div>
                                  {touched.password && errors.password &&
                                    <p className='errorMsg'>{errors.password as string}</p>
                                  }
                                </div>
                              </div>
                            </div>
                            {/* <div className="row mb-8">
                             <div className="col-md-6">
                               <div className="wrapper">
                                <Select
                                  value={selectedOptionCountry}
                                  id="CountryId"
                                  className="basic-single fs-7 fw-normal"
                                  classNamePrefix="select"
                                  isSearchable={true}
                                  name="CountryId"
                                  onBlur={() => setFieldTouched('CountryId', true)}
                                  onChange={(e) => handleChangeCountry(e, 'CountryId', values)}
                                  options={countryArray}
                                  styles={dropDownSelectionStyles}
                                  maxMenuHeight={maxMenuHeight}
                                />
                              </div>  
                              </div>  
                              <div className="col-md-6">
                                <div className="wrapper">
                                  <input
                                    type="text"
                                    placeholder="Subdomain"
                                    name="subdomain"
                                    value={values.subdomain}
                                    onChange={handleChange('subdomain')}
                                    onBlur={() => {
                                      setFieldTouched('subdomain', true);
                                      checkSubDomain(values.subdomain, setFieldError, setFieldValue);
                                    }}
                                    className="form-control fs-6 fw-normal"
                                  />
                                  <span className="insideField-Icons form-label fs-6 fw-normal">{('.livetecs.com')}</span>
                                </div>
                                <div>
                                  {touched.subdomain && errors.subdomain &&
                                    <p className='errorMsg'>{errors.subdomain as string}</p>
                                  }
                                </div>
                              </div>
                                                  
                            </div> */}

                            <div className="fv-row mb-8 fv-plugins-icon-container">
                              <div className="wrapper">
                                  <input
                                    type="text"
                                    placeholder="Subdomain"
                                    name="subdomain"
                                    value={values.subdomain}
                                    onChange={handleChange('subdomain')}
                                    onBlur={() => {
                                      setFieldTouched('subdomain', true);
                                      checkSubDomain(values.subdomain, setFieldError, setFieldValue);
                                    }}
                                    className="form-control fs-6 fw-normal"
                                  />
                                  <span className="insideField-Icons form-label fs-6 fw-normal">{('.livetecs.com')}</span>
                                </div>
                                <div>
                                  {touched.subdomain && errors.subdomain &&
                                    <p className='errorMsg'>{errors.subdomain as string}</p>
                                  }
                                </div>
                            </div>
                          

                           
                            <div className="d-grid mb-4">
                              <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight fs-6"
                                onClick={() => handleSubmit()}
                                disabled={!isValid}
                              >
                                {('Sign Up')}
                              </button>
                            </div>
                            <div className="text-gray-500 text-center fs-6">
                              Already have an account?
                              <Link to='/auth/login'>
                                <a href="/metronic8/demo1/authentication/layouts/overlay/sign-up.html" className="text-primaryTL cursor ms-1">
                                  Sign In
                                </a>
                              </Link>{' '}
                            </div>
                          </div>
                        </div>
                        <div className=" d-flex flex-stack">
                          <div className="text-gray-500 text-center fs-6 mt-8">
                            Review our
                            <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                              {('Terms Of Use')}
                            </a> and<a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                              {('Privacy Policy.')}
                            </a> Explore Pricing of <a href="https://www.livetecs.com/on-demand-price/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                              {('On-Cloud')}
                            </a> and <a href="https://www.livetecs.com/on-premises-price/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                              {('On-Premises')}
                            </a> Solutions
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  )
}